'use client';

import React, { createContext, useContext, useEffect } from 'react';
import { useTraceFiltersContext } from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import { SessionService } from '@users/session/SessionService';
import { getContainer } from '@framework/di/getContainer';
import { TTraceFiltersPayload } from '@/creditflowresearch/domain/vo/Trace/IMarketTradesPayload';

interface ITileContextProviderProps {
  filterPayload?: { filter?: TTraceFiltersPayload },
  sectorItem?: {
    sectorId: string,
    subsectorId: string,
  },
  children: React.ReactNode,
}

export const useTile = ({ filterPayload }: Omit<ITileContextProviderProps, 'children'>) => {
  const container = getContainer();
  const { payloadChange } = useTraceFiltersContext();
  const sessionService = container.get(SessionService);

  const init = async () => {
    payloadChange(filterPayload.filter);
  };

  useEffect(() => {
    if (sessionService.currentUser) init();
  }, [sessionService.currentUser, filterPayload.filter]);

  return {};
};

type TileContextType = ReturnType<typeof useTile>;

export const TraceTileContext = createContext<TileContextType>(null);

export const useTraceTileContext = () => {
  const context = useContext(TraceTileContext);
  if (!context) {
    throw new Error('useTraceTileContext must be used within the TraceTileContext');
  }
  return context;
};

const TraceTileContextProvider = ({ children, filterPayload }) => (
  <TraceTileContext.Provider value={ useTile({ filterPayload }) }>
    { children }
  </TraceTileContext.Provider>
);

export default TraceTileContextProvider;
